// extracted by mini-css-extract-plugin
module.exports = {"pdfIframe":"pdf_pdfIframe__3KuTx"};